import React, { useState } from "react";
import { FiArrowUpCircle  } from "react-icons/fi";
import styles from "../../styles/AccountBilling/Subscription.module.css";
import teamStyles from "../../styles/AccountBilling/ManageTeam.module.css";

const payments = [
    { date: "dd/mm/yyyy", plan: "Pro Plan", total: "$100", status: "Pending", action: "Pay now", },
    { date: "dd/mm/yyyy", plan: "Pro Plan", total: "$100", status: "Paid", action: "View invoice", },
    { date: "dd/mm/yyyy", plan: "Pro Plan", total: "$100", status: "Paid", action: "View invoice", },
];
const Billing = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        NextPaymentDate: "dd/mm/yyyy",
        TotalCost: "$200",
        ActiveSince: '2025',
        BrandWorkspacesUsed: "1/2",
        UsersUsed: "2/10",
        PostsPerMonth: "100/Unlimited",
    });

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        setIsEditing(false);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    return (
        <div class="company-management-card">
            <div className={styles.detailsHeader}>
                <span className={styles.detailsHeading} >Billing</span>
                {!isEditing ? (
                    <button className={styles.editBtn} onClick={handleEditClick}>
                        <FiArrowUpCircle /> Upgrade plan
                    </button>
                ) : (
                    <button className={styles.saveBtn} onClick={handleSaveClick}>
                        Save
                    </button>
                )}
            </div>
            <div className="separator" />
            <div className={styles.detailsContent}>
                <div className={styles.detailItem}>
                    <span className={styles.detailLabel}>Next Payment Date</span>
                    {isEditing ? (
                        <input
                            type="text"
                            name="NextPaymentDate"
                            value={formData.NextPaymentDate}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{formData.NextPaymentDate}</p>
                    )}
                </div>

                <div className={styles.detailItem}>
                    <span className={styles.detailLabel}>Total Cost</span>
                    {isEditing ? (
                        <input
                            type="text"
                            name="TotalCost"
                            value={formData.TotalCost}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{formData.TotalCost}</p>
                    )}
                </div>
                <div className={styles.detailItem}>
                    <span className={styles.detailLabel}>Active Since</span>
                    {isEditing ? (
                        <input
                            type="text"
                            name="ActiveSince"
                            value={formData.ActiveSince}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{formData.ActiveSince}</p>
                    )}
                </div>
                {/* Plan Details Section */}
                <div className={styles.detailItem}>
                    <span className={styles.detailLabel}>Previous payments</span>
                    <div className={styles.planDetailsGrid}>
                        <div className={styles.planDetailRow}>
                            <span>Brand Workspaces</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    name="BrandWorkspacesUsed"
                                    value={formData.BrandWorkspacesUsed}
                                    onChange={handleChange}
                                />
                            ) : (
                                <span>{formData.BrandWorkspacesUsed}</span>
                            )}
                        </div>

                        <div className={styles.planDetailRow}>
                            <span>Users</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    name="UsersUsed"
                                    value={formData.UsersUsed}
                                    onChange={handleChange}
                                />
                            ) : (
                                <span>{formData.UsersUsed}</span>
                            )}
                        </div>

                        <div className={styles.planDetailRow}>
                            <span>Post per month</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    name="PostsPerMonth"
                                    value={formData.PostsPerMonth}
                                    onChange={handleChange}
                                />
                            ) : (
                                <span>{formData.PostsPerMonth}</span>
                            )}
                        </div>
                    </div>
                </div>
                {/* Payments Table */}
                <div className={teamStyles.tableContainer}>
                    <table className={teamStyles.teamTable}>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Plan purchased</th>
                                <th>Invoice total</th>
                                <th>Status</th>
                            
                            </tr>
                        </thead>
                        <tbody>
                            {payments.map((payment, index) => (
                                <tr key={index}>
                                    <td>{payment.date}</td>
                                    <td>{payment.plan}</td>
                                    <td>{payment.total}</td>
                                    <td>
                                        {payment.status}{" "}
                                       
                                    </td>
                                    <td>
                                    <span className={styles.invoiceAction}>
                                            {payment.action}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button className={teamStyles.addMemberBtn}>+ Add new member</button>
                </div>
                <br></br>
                <br></br>
                <br></br>
            </div>
        </div>
    );
};

export default Billing;